import React from "react";
import { MSTableDefaultStickyCell } from "@pages/managed-accounts/model-screener/components/model-screener-table/rendered-fields/sticky-cell";
import { SHStack } from "@components/design-systems";
import { MSTableTooltip } from "@pages/managed-accounts/model-screener/components/model-screener-table/rendered-fields/tooltip";
import { ModelScreenerFieldType } from "@models/model-screener/enums/fieldType";
import { ModelScreenerCellData } from "@models/model-screener/entities/modelScreenerData";
import { MSTableCellComponentMap } from "@pages/managed-accounts/model-screener/constant";
import {
  MSTableTextShortCell
} from "@pages/managed-accounts/model-screener/components/model-screener-table/rendered-fields/text-short-cell";

type MSCellLayoutProps = {
  cellData: ModelScreenerCellData;
  fieldType: ModelScreenerFieldType;
  isDefaultStickyCells: boolean;
};

export const MSTableCellLayout = React.memo(
  ({ cellData, fieldType, isDefaultStickyCells }: MSCellLayoutProps) => {
    const CellComponent = isDefaultStickyCells
      ? MSTableDefaultStickyCell
      : MSTableCellComponentMap[fieldType] || MSTableTextShortCell;

    return (
      <SHStack direction={"row"} alignItems={"center"} gap={1}>
        <CellComponent cellData={cellData} />
        <MSTableTooltip cellData={cellData} />
      </SHStack>
    );
  },
);
